export const sortByCategoryAndLabel = (data) => {
const categories = data.filter(
  (item) => item.type === "category" && item.label !== undefined
);  const items = data.filter((item) => !item.type);

  // Sort categories by label
  categories.sort((a, b) => a.label.localeCompare(b.label));

  // Sort items by category first, then label
  const sortedItems = items.sort((a, b) => {
    if (a.category === b.category) return a.label.localeCompare(b.label);
    return a?.category?.localeCompare(b.category);
  });

  const sortedData = [];

  categories.forEach((category) => {
    sortedData.push(category);

    // Filter and sort items in this category by firstName
    const itemsInCategory = sortedItems
      .filter((item) => item.category === category.label)
      .sort((a, b) =>
        a.firstName?.localeCompare(b.firstName, "en", { sensitivity: "base" })
      );

    sortedData.push(...itemsInCategory);
  });

  return sortedData|| [];
};
